module.exports = __webpack_public_path__ + "static/media/astronaut.889f6ba8.svg";